<script setup lang="ts">
import type { Layer } from "@/types/legend.types";
import LegendLib from "@/utils/LegendLib";
import { computed } from "vue";

const props = defineProps<{
  layer: Layer;
}>();

const color = computed(() => {
  return LegendLib.toHex(props.layer.color);
});
</script>

<template>
  <div class="d-flex gap-3 align-items-center">
    <i class="bi-layers-fill" :style="{ fontSize: '20px', color }"></i>
    <div>{{ layer.name }}</div>
  </div>
</template>

<style lang="scss" scoped>
.tag {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
</style>
